import { ANALYTICS_EVENTS, ANALYTICS_PROPERTY_KEYS, COMPONENT_OUTCOMES } from '../constants';
import { getCurrentPagePath, trackAnalyticsEvent } from '../core/analyticsClient';
import { getPageFromPath } from '../utils';

export const trackRageClick = (elementSelector: string, clickCount: number): void => {
  const pagePath = getCurrentPagePath() ?? window.location.pathname;

  trackAnalyticsEvent(ANALYTICS_EVENTS.RAGE_CLICK_DETECTED, {
    [ANALYTICS_PROPERTY_KEYS.ELEMENT_SELECTOR]: elementSelector,
    [ANALYTICS_PROPERTY_KEYS.CLICK_COUNT]: clickCount,
    [ANALYTICS_PROPERTY_KEYS.PAGE_PATH]: pagePath,
    [ANALYTICS_PROPERTY_KEYS.PAGE]: getPageFromPath(pagePath),
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.AUTO,
  });
};
